import PreferencesEmail from './preferences-email.connect'

export default PreferencesEmail
